import Button from '../atoms/Button';
import SearchInput from '../molecules/SearchInput';

/**
 * ListToolbar — search + filter slots + auto "Reset Filter".
 *
 * Pass `search`/`onSearchChange` for the search field; put filter controls
 * (MultiSelect, Dropdown, DateRangePicker…) in `children`. The reset button
 * shows only when `hasActiveFilters` is true.
 */
export default function ListToolbar({
  search,
  onSearchChange,
  searchPlaceholder,
  children,
  hasActiveFilters = false,
  onReset,
  actions,
  className = '',
}) {
  return (
    <div className={`list-toolbar ${className}`.trim()}>
      {onSearchChange && (
        <SearchInput
          value={search ?? ''}
          onChange={onSearchChange}
          placeholder={searchPlaceholder}
        />
      )}
      {children}
      {hasActiveFilters && onReset && (
        <Button variant="ghost" size="sm" onClick={onReset}>
          Reset Filter
        </Button>
      )}
      {actions && <div className="list-toolbar__actions">{actions}</div>}
    </div>
  );
}
